module.exports = {
  name: 'Playamopartners',
  title: 'Best online casino affiliate program - Playamopartners',
  description: 'Join our online casino affiliate program and enjoy the benefits of working with real professionals',
  type: 'website',
  url: 'https://playamopartners.com',
  image: '/assets/images/og.png',
  locales: ['en', 'ja', 'es', 'pt', 'cn', 'ms', 'vi']
};
